// DEV-1003: the tabs of the paged Data Requests list. Values match the backend DataRequestListTab enum.
export enum DataRequestListTabEnum {
    AwaitingMyAction = 'AwaitingMyAction',
    Draft = 'Draft',
    Active = 'Active',
    NotApproved = 'NotApproved',
    Withdrawn = 'Withdrawn',
    Archived = 'Archived'
}

// DEV-1003: the only fields a Data Requests page may be sorted by. Values match the backend
// DataRequestSummarySortField enum. DataRequestDoi is the stored field behind idString.
export enum DataRequestSummarySortFieldEnum {
    DataRequestDoi = 'DataRequestDoi',
    CreatedTime = 'CreatedTime',
    UpdatedDate = 'UpdatedDate',
    // DEV-958: the grid's sortable columns. Status is paged per status in the display order the
    // grid sends (statusOrder); the others order by sort keys stored on the document.
    RequestTitle = 'RequestTitle',
    RequestedStudyCount = 'RequestedStudyCount',
    LeadResearcher = 'LeadResearcher',
    Requester = 'Requester',
    Status = 'Status'
}

// DEV-958: how the Total Studies column filter compares. Values match the backend NumberFilterOperator enum.
export enum NumberFilterOperatorEnum {
    Equals = 'Equals',
    GreaterThan = 'GreaterThan',
    LessThan = 'LessThan'
}
